/**
 * Zu eventuellen Form-Fehlern scrollen
 */
export default function scrollToErrors() {
  const error = document.querySelector('.control-group.has-error');
  if (error) {
    error.scrollIntoView({ behavior: 'smooth' });
  }
}
